import React from 'react';
import DatePicker from 'react-datepicker';

function CustomDateRadio({
  selectedStart,
  selectedEnd,
  onChangeStart,
  onChangeEnd,
  startDate,
  endDate,
  maxDate,
  minDate,
}) {
  return (
    <div className="flex items-center gap-2 border-t border-t-grey5 pt-3 px-4 mt-3 w-full">
      <div className="flex flex-col items-start lookup-filter w-full">
        <span className="text-xs text-body font-medium mb-[5px]">FROM</span>
        <DatePicker
          selected={selectedStart}
          onChange={onChangeStart}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          showYearDropdown
          maxDate={maxDate}
        />
      </div>
      <div className="flex flex-col items-start w-full">
        <span className="text-xs text-body font-medium mb-[5px]">TO</span>
        <DatePicker
          selected={selectedEnd}
          onChange={onChangeEnd}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={minDate}
          showYearDropdown
          maxDate={maxDate}
        />
      </div>
    </div>
  );
}

export default CustomDateRadio;
